import * as React from 'react';
import {useEffect, useContext, useState} from 'react';
import {UserInfo} from '../queries/userInfo';
import {UserInfoContext} from '../context/userInfoContext';
import {SwitchContext} from '../context/switchContext';
import {useKeycloak} from '@react-keycloak/web';
import useToken from '../../useToken';
import {useAuthentication} from '../../auth/hooks/useAuthentication';



export const useUserInfo = () => {
  const {state, dispatch} = useContext(UserInfoContext);
  const {stateSwitch, dispatchSwitch} = useContext(SwitchContext);
  const {keycloak, initialized} = useKeycloak();
  const {token, revertToken} = useToken();
  const {isAuthenticated} = useAuthentication();
  const [isLoading, setIsLoading] = useState(true);



  useEffect(() => {
    console.log('token', token,'state', state)
    if (token && !state) {
      UserInfo.getUserInfo().then(response => {
          setIsLoading(false);
          dispatch({type: 'initUserInfo', payload: response})
      });
    }
    setIsLoading(false);
  }, [token]);

  useEffect(() => {
    const initial = localStorage.getItem('main_token');
    if (initial !== null) {
      dispatchSwitch({type: 'initSwitch', payload: true});
    }
  }, []);

  const reload = () => {
    UserInfo.getUserInfo().then(response =>
      dispatch({type: 'initUserInfo', payload: response}),
    );
  };

  const setToSwitchMode = switchMode => {
    dispatchSwitch({type: 'initSwitch', payload: switchMode});
    console.log('switch');
  };

  const revertAccount = () => {
    revertToken();
    setToSwitchMode(false);
    window.location.reload();
  }


  return {profil: state, reload, switchMode: stateSwitch, setToSwitchMode, revertAccount, isLoadingProfile: isLoading};
};
